import React from "react";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Unchecked } from "../../assets/analyse/Unchecked.svg";
import { ReactComponent as Reducearrow } from "../../assets/analyse/proposition_arrow.svg";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as RecipeImg } from "../../assets/analyse/AnalyseRecipe.svg";
import { ReactComponent as DeliveryIcon } from "../../assets/analyse/DeliveryIcon.svg";
import { ReactComponent as ConsumptionIcon } from "../../assets/analyse/consumption.svg";
import { ReactComponent as RetailIcon } from "../../assets/analyse/retail.svg";
import { ReactComponent as DistributionIcon } from "../../assets/analyse/distribution.svg";
// import { columnsNames } from "../../css/columns";
import AnalysisLine from "./AnalysisLine";
import { useState } from "react";
import { green } from "@mui/material/colors";
import ReduceAnalysisLine from "./ReduceAnalysisLine";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const ReduceSubstep = ({ name, icon, data, width, hidden, setHidden, columns, step, totalScore, ingredients, depth }) => {
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));
  const hiddenindex = step + depth * 5;
  // const [hide, setHide] = useState("");
  width -= 30;
  return (
    <>
      <div>
        <div className={`h-[40px] bg-white border-[0.1px] boder-[#F3F5F7] flex w-max`}>
          <div style={{ width: width }} className={`items-center flex justify-between`}>
            <button
              className="flex items-center"
              onClick={() => {
                // setHiden(!hiden);
                let newhidden = [...hidden];
                newhidden[hiddenindex] = !newhidden[hiddenindex];
                setHidden(newhidden);
              }}
            >
              {/* <BackArrow transform={`rotate(${270 - 90 * (hide ? hide : 0)})`} className="ml-[15px]" height={10} /> */}
              <BackArrow transform={`rotate(${270 - 90 * (hidden[hiddenindex] ? hidden[hiddenindex] : 0)})`} className="ml-[15px]" height={10} />

              <div className={"w-[40px] justify-center flex"}>
                {icon === "Recette" ? (
                  <RecipeImg height={20} />
                ) : icon === "Packaging" ? (
                  <DeliveryIcon height={20} />
                ) : icon === "Distribution" ? (
                  <DistributionIcon height={20} />
                ) : icon === "Vente au détail" ? (
                  <RetailIcon height={20} />
                ) : icon === "Consommation" ? (
                  <ConsumptionIcon height={20} />
                ) : null}
              </div>
              <p className="font-Poppins-SemiBold">{name}</p>
            </button>
          </div>

          {/* {columns.map((current, i) => {
            return (
              <div>
                <div
                  key={`${current} ${i}`}
                  // style={"bg-[red]"}
                  className={`h-[40px] w-[${impact_indicators.find((target) => target.id === current).width}px] flex justify-center items-center border-l-[0.1px] border-dotted border-[#F3F5F7]`}
                >
                  <div className="h-[4px] w-[80%] bg-[#BEC4CA]/50 rounded-2xl" />
                </div>
              </div>
            );
          })} */}
        </div>

        {hidden[hiddenindex] ? null : (
          <>
            <div className="ml-[30px]">
              <ReduceAnalysisLine
                width={width}
                // checked={0}
                color={null}
                // step={step}
                // columns={columns}
                icon={data.custom_analysis.flow.category.name}
                // impact_factors={data.custom_analysis.flow.flow_impact_factors}
                item={data.custom_analysis.flow.name_fr}
                // quantity={data.custom_analysis.amount}
                // quantityUnit={data.custom_analysis.unit.name}
                flow_id={data.custom_analysis.id}
                // line_index={1}
                // changable={step <= 2 ? null : data.custom_analysis}
                is_reduce={true}
              />
              <ReduceAnalysisLine
                width={width}
                // checked={0}
                color={"green"}
                // step={step}
                // columns={columns}
                icon={data.custom_analysis.flow.category.name}
                // impact_factors={data.optimization_results.flow.flow_impact_factors}
                item={data.optimization_results.flow.name_fr}
                // quantity={data.optimization_results.amount}
                // quantityUnit={data.optimization_results.unit.name}
                flow_id={data.optimization_results.id}
                // line_index={1}
                // changable={step <= 2 ? null : data.optimization_results}
                is_reduce={true}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ReduceSubstep;
